export default __webpack_public_path__ + "static/media/image.477e01ea.png";